import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService } from '../../../../tms-shared';
import { SalesOrderHeaderExtraItem } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderExtraItemService extends TmsWebBaseEditCreateService<
  SalesOrderHeaderExtraItem,
  SalesOrderHeaderExtraItem
> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SalesOrderExtraItem', $localize`Sales Order Extra Item`, httpService, notificationService);
  }

  getForSalesOrderHeader(id: string): Observable<SalesOrderHeaderExtraItem[]> {
    return this.httpService.get<SalesOrderHeaderExtraItem[]>(`${this.apiUrl}/SalesOrderHeader?id=${id}`);
  }
}
